import { gql } from '@apollo/client';

export const DeleteKnowledgeData = gql`
    mutation deleteKnowledgeData($knowledgeDataId: ID!) {
        deleteKnowledgeData(knowledgeDataId: $knowledgeDataId) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
